/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  style.ts
 */

// import homepageLogoSm from './img/homepage-logo-small.svg'
import { css } from '@emotion/react'
import {
  BREAKPOINT_480,
  BREAKPOINT_1080,
  BREAKPOINT_DESKTOP,
  BREAKPOINT_MOBILE,
  Z_INDEX_FIXED,
  Z_INDEX_GROUP_1,
} from '@zcode-ui/themes'
import homepageDesktopDark from './img/homepage-desktop-dark.svg'
import homepageDesktopSpooky from './img/homepage-desktop-halloween.svg'
import homepageDesktopZumperRentals from './img/homepage-desktop-zumper-rentals.svg'
import homepageDesktop from './img/homepage-desktop.svg'
import homepageLogoSmDark from './img/homepage-logo-small-dark.svg'
import homepageMobileDark from './img/homepage-mobile-dark.svg'
import homepageMobileSpooky from './img/homepage-mobile-halloween.svg'
import homepageMobileZumperRentals from './img/homepage-mobile-zumper-rentals.svg'
import homepageMobile from './img/homepage-mobile.svg'

export const headerContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #F3F1EA;

  nav {
    @media (max-height: 900px) {
      background: transparent;
    } 
  }
`

export const navContainer = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${Z_INDEX_FIXED};
`

export const hero = css`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;

  width: 100%;
  height: calc(100vh - 66px);
  max-height: 1600px;
  z-index: ${Z_INDEX_GROUP_1};

  background-color: #f5f1e9;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    height: 60vh;
    /* mobile viewport bug fix for Safari engine browsers */
    /* @supports (-webkit-touch-callout: none) {
      height: -webkit-fill-available;
    } */
  }
`

export const heroHalloween = css`
  background: #0f4c52;
`

export const heroDark = ({ colors }: any) => css`
  background-color: ${colors?.blue?.['800']};
`

export const heroContent = css`
  position: absolute;
  top: 0;
  left: 50%;
  display: flex;
  justify-content: center;

  width: 100%;
  max-width: 1000px;

  transform: translateX(-50%);

  @media (max-width: ${BREAKPOINT_1080}) {
    width: calc(100% - 80px);
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    top: 0;
    right: 0;
    left: 0;

    width: 100%;
    margin: 0 auto;

    transform: none;
  }
`

export const image = css`
  background-image: url(${homepageDesktop});

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    background-image: url(${homepageMobile});
  }
`
export const imageZumperRentals = css`
  background-image: url(${homepageDesktopZumperRentals});

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    background-image: url(${homepageMobileZumperRentals});
  }
  @media (min-width: ${BREAKPOINT_MOBILE}) {
    background-size: calc(1446px * 1.3) calc(653px * 1.3);
  }
`

export const imageDimensions = css`
  height: 200%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: initial;
  background-position: bottom;

  @media (min-width: 2001px) {
    background-size: contain;

    -ms-background-size: contain;
    -o-background-size: contain;
    -moz-background-size: contain;
    -webkit-background-size: contain;
  }
`

export const imageDark = css`
  background-image: url(${homepageDesktopDark});
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    background-image: url(${homepageMobileDark});
  }
`

export const imageHalloween = css`
  background-image: url(${homepageDesktopSpooky});
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    background-image: url(${homepageMobileSpooky});
  }
`

export const logo = css`
  position: absolute;
  right: 50%;
  top: 25%;
  transform: translateX(50%);

  svg {
    width: 100%;
    height: 100%;
  }
`

export const logoDark = css`
  background-image: url(${homepageLogoSmDark});
`

export const headerContent = css`
  height: 100vh;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    width: 100%;
  }
`

export const contentContainer = css`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 400px;

  @media (max-height: 768px) and (min-width: ${BREAKPOINT_DESKTOP}) {
    padding-bottom: 200px;
  }
`

export const content = css`
  display: flex;
  justify-content: center;
`
